import { FACEBOOK_ANALYTICS_ID, CB2_FACEBOOK_ANALYTICS_ID } from '../../config/analytics';

// TODO: Can't place this in AppHelmet currently
// won't be ready for inital event. need initial event listen
// for onload event, then can be placed in app helmet to be consistent
// with other tags
const createFBObject = () => {
  if (!window.fbq) {
    !(function (f, b, e, v, n, t, s) { // eslint-disable-line
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq)f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
      n.queue = []; t = b.createElement(e); t.async = !0;
      t.src = v; s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script',
      'https://connect.facebook.net/en_US/fbevents.js'));
  }
};

export const initializeModsyPixel = (userData) => {
  createFBObject();
  try {
    window.fbq('init', FACEBOOK_ANALYTICS_ID, userData);
  } catch (error) {
    window.bugsnag.notify(error);
  }
};

// may not be needed as pixel default fires pageviews on history state change
export const trackPageView = (location) => {
  if (window.fbq) {
    window.fbq('trackSingle', FACEBOOK_ANALYTICS_ID, 'PageView');
  }
};

export const trackDesignPackageSelect = ({packageSku, packagePrice, packageName}) => {
  if (window.fbq) {
    window.fbq(
      'trackSingle',
      FACEBOOK_ANALYTICS_ID,
      'ViewContent',
      {
        content_type: 'product',
        content_ids: packageSku,
        value: packagePrice,
        content_name: packageName,
        currency: 'USD'
      }
    );
  }
};

export const trackAddPackageToCart = ({packageSku, packagePrice, packageName, userId = 0}) => {
  if (window.fbq) {
    window.fbq(
      'trackSingle',
      FACEBOOK_ANALYTICS_ID,
      'AddToCart',
      {
        content_type: 'product',
        content_ids: packageSku,
        value: packagePrice,
        content_name: packageName,
        currency: 'USD',
        external_id: userId,
        event_id: 'addpackagetocart.' + packageSku + '.' + userId
      }
    );
  }
};

export const trackRegistration = userId => {
  if (window.fbq) {
    window.fbq(
      'trackSingle',
      FACEBOOK_ANALYTICS_ID,
      'CompleteRegistration',
      {
        external_id: userId,
        event_id: 'registration.' + userId
      },
      {
        eventID: 'registration.' + userId
      }
    );
    window.fbq('trackCustom', 'synthetic_web_purchase');
  }
};

export const trackPackagePurchase = ({ orderTotal, orderNumber = 0, itemName, userId = 0 }) => {
  if (window.fbq) {
    window.fbq(
      'trackSingle',
      FACEBOOK_ANALYTICS_ID,
      'Purchase',
      {
        content_name: itemName,
        value: orderTotal,
        currency: 'USD',
        external_id: userId
      },
      {
        eventID: 'packagepurchase.' + orderNumber + '_u' + userId
      }
    );
  }
};

const initializeCB2Pixel = () => {
  createFBObject();
  try {
    window.fbq('init', CB2_FACEBOOK_ANALYTICS_ID);
  } catch (error) {
    window.bugsnag.notify(error);
  }
};

export const cb2TrackSignUp = () => {
  if (window.fbq) {
    initializeCB2Pixel();
    // need to manually fire pageview on initial load of cb2 pixel
    window.fbq('trackSingle', CB2_FACEBOOK_ANALYTICS_ID, 'PageView');
    window.fbq('trackSingle', CB2_FACEBOOK_ANALYTICS_ID, 'Search');
  }
};

export const cb2TrackPackagePurchase = () => {
  if (window.fbq) {
    initializeCB2Pixel();
    window.fbq('trackSingle', CB2_FACEBOOK_ANALYTICS_ID, 'CompleteRegistration');
    window.fbq('trackCustom', 'synthetic_web_purchase');
  }
};

export const trackMerchPurchase = ({ displayedInfo }) => {
  if (window.fbq) {
    const {
      displayedShipping,
      displayedTax,
      displayedTotal
    } = displayedInfo;

    // displayed total less shipping and handling
    // should be the total after discounts have been applied
    const totalLessDiscounts = parseFloat(displayedTotal) -
      parseFloat(displayedTax) - parseFloat(displayedShipping);

    window.fbq('trackCustom', 'Merch Sales Purchase', {
      value: totalLessDiscounts.toFixed(2),
      currency: 'USD'
    });
  }
};
